import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CKEditorModule } from 'ngx-ckeditor';
import { ChartsModule } from 'ng2-charts';
import { CookieService } from 'ngx-cookie-service';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MaterialModule } from './material/material.module';
import { GoogleMapsModule } from '@angular/google-maps';
import { NotificationService } from './shared/Notification.service';
import { AppComponent } from './app.component';
import { LoadingComponent } from './loading/loading.component';
import { HomepageComponent } from './homepage/homepage.component';
import { LoHangTapTinDinhKemDetailComponent } from './lo-hang-tap-tin-dinh-kem-detail/lo-hang-tap-tin-dinh-kem-detail.component';
import { LoHangPhanAnhDetailComponent } from './lo-hang-phan-anh-detail/lo-hang-phan-anh-detail.component';
import { ToChucDetailComponent } from './to-chuc-detail/to-chuc-detail.component';
import { LoHangBinhChonDetailComponent } from './lo-hang-binh-chon-detail/lo-hang-binh-chon-detail.component';
import { EmptyComponent } from './empty/empty.component';



@NgModule({
  declarations: [
    AppComponent,
    LoadingComponent,
    HomepageComponent,
    LoHangTapTinDinhKemDetailComponent,
    LoHangPhanAnhDetailComponent,
    ToChucDetailComponent,
    LoHangBinhChonDetailComponent,
    EmptyComponent,   
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    GoogleMapsModule,
    ChartsModule,
    CKEditorModule,
  ],
  providers: [
    CookieService,
    NotificationService,
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
